/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";
import parseHtmlContent from "helpers/parseHtmlContent";

import {colors} from "nxtconstants";

import {
  SectionTitle,
  container
} from "../common";

const RegulatoryCharges = ({
  regulatoryCharges
}) => {
  const loadCharges = (
    regulatoryCharges.map((dataItem, rowIndex) => (
      <tr key={rowIndex}>
        {
          Object.values(dataItem).map((item, colIndex) => (
            <td key={colIndex}>
              {parseHtmlContent(item)}
            </td>
          ))
        }
      </tr>
    ))
  );

  return (
    <ChargesWrapper>
      <SectionTitle>
        Regulatory & Statutory Charges
      </SectionTitle>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th>Charges</th>
              <th>Equity (Delivery)</th>
              <th>Equity (Intraday)</th>
              <th>Futures</th>
              <th>Options</th>
            </tr>
          </thead>
          <tbody>
            {loadCharges}
          </tbody>
        </Table>
      </TableWrapper>
    </ChargesWrapper>
  );
};

const ChargesWrapper = styled(container)``;

const TableWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

const Table = styled.table`
  table-layout: fixed;
  width: 100%;
  text-align: left;
  border-radius: 1.5rem;
  overflow: hidden;
  border-collapse: collapse;
  margin-top: 4.4rem;

  th {
    font-size: 2.4rem;
    background-color: ${colors.pastelPurple};
    color: ${colors.white};
    padding: 2.7rem 3rem;
    border: 1px solid #fff;
    border-top: 0;

    &:first-child {
      border-left-width: 0;
    }

    &:last-child {
      border-right-width: 0;
    }
  }

  td {
    background-color: ${colors.magnolia};
    padding: 4rem 3rem;
    font-size: 2rem;
    color: ${colors.jetBlack};
    border: 1px solid #DDD;
    border-bottom: 0;

    &:first-child {
      border-left-width: 0;
    }

    &:last-child {
      border-right-width: 0;
    }

    h3 {
      font-size: 2rem;
    }

    span {
      color: ${colors.black};
      font-size: 2.4rem;
      font-weight: bold;
    }
  }

  @media (max-width: 768px) {
    margin-top: 3.2rem;
    table-layout: unset;

    th, td {
      font-size: 1.6rem;
      padding: 3rem 2rem;

      span {
        font-size: 1.8rem;
      }
    }
  }
`;

export default RegulatoryCharges;
